/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';
import { COLORS } from 'colors';

export const TestimonialSection = styled.div`
  background-color: ${COLORS.GRAY_50};
`;

export const Container = styled.div`
  max-width: 1440px;
  margin: 0 auto;
  padding: 2rem 1rem;
  background-color: ${COLORS.GRAY_50};
  @media (min-width: 767px) {
    padding: 4rem 5rem;
  }
  .below-content-btn {
    display: block;
    margin-top: 2rem;
    display: flex;
    justify-content: center;
  }
  @media (min-width: 767px) {
    .below-content-btn {
      margin-top: 4rem;
    }
  }
  @media (min-width: 1024px) {
    .below-content-btn {
      display: none;
    }
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 4rem;
  align-items: center;
  gap: 2rem;
  .right-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.5rem;
  }
  .right-content-btn {
    display: none;
  }
  @media (min-width: 1024px) {
    flex-direction: row;
    align-items: normal;
    .right-content {
      align-items: normal;
    }
    .right-content-btn {
      display: block;
    }
  }
  @media (min-width: 1248px) {
    gap: 21rem;
  }
`;

export const Title = styled.h1`
  max-width: 336px;
  font-size: 34px;
  font-weight: 600;
  color: ${COLORS.BLACK};
  line-height: 114.9%;
  letter-spacing: -2px;
  @media (min-width: 767px) {
    max-width: 480px;
    font-size: 50px;
  }
`;

export const Highlight = styled.span`
  color: ${COLORS.ORANGE};
  .cta-br {
    display: none;
  }
  @media (min-width: 1200px) {
    .cta-br {
      display: block;
    }
  }
`;

export const Subtitle = styled.p`
  display: flex;
  align-items: center;
  color: ${COLORS.GRAY_700};
  max-width: 336.07px;
  font-size: 16px;
  line-height: 30px;
  font-weight: 400;
  letter-spacing: -1px;
  @media (min-width: 767px) {
    max-width: 467.71px;
    font-size: 20px;
  }
`;

export const NavButtons = styled.div`
  display: flex;
  gap: 1rem;
`;

export const IconButton = styled.button`
  width: 59.12px;
  height: 59.12px;
  background-color: ${({ black }) => (black ? COLORS.BLACK : 'transparent')};
  border: 1.41px solid ${COLORS.BLACK};
  border-radius: 50%;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease-out, box-shadow 0.3s ease-out;

  &:hover {
    transform: scale(1.1);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08);
  }


`;

export const TestimonialGrid = styled.div`
  display: flex;
  flex-direction: column-reverse;
  background-color: ${COLORS.WHITE};
  .lft-col {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    padding: 3rem 1rem;
  }
  @media (min-width: 1024px) {
    display: grid;
    grid-template-columns: 2fr 436.16px;
    .lft-col {
      padding: 3rem 2rem;
      justify-content: space-between;
    }
  }
`;

export const Quote = styled.blockquote`
  font-size: 24px;
  color: ${COLORS.BLACK};
  line-height: 130%;
  // max-width: 754.82px;
  letter-spacing: -1px;
  font-weight: 600;
  @media (min-width: 768px) {
    font-size: 28px;
  }
`;

export const Person = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const Name = styled.p`
  font-weight: 600;
  font-size: 20px;
  line-height: 130%;
  letter-spacing: 2%;
  color: ${COLORS.BLACK};
  @media (min-width: 768px) {
    font-size: 24px;
  }
`;

export const Role = styled.p`
  color: ${COLORS.GRAY_700};
  font-weight: 400;
  font-size: 18px;
  line-height: 30px;
  @media (min-width: 768px) {
    font-size: 20px;
  }
`;

export const ImageWrapper = styled.div`
  display: flex;
  justify-content: normal;
  align-items: normal;
  width: auto;
  height: 100%;
  overflow: hidden;

  img {
    width: 100%;
    height: 272.2px;
    object-fit: cover;
    object-position: center;
  }
  @media (min-width: 1024px) {
    justify-content: flex-end;
    align-items: flex-end;
    width: 100%;
  }
  @media (min-width: 400px) {
    img {
      height: 547.51px;
      object-fit: cover;
    }
  }
`;
